import { render, staticRenderFns } from "./AdministrationForecast.vue?vue&type=template&id=e554eda4"
import script from "./AdministrationForecast.vue?vue&type=script&lang=js"
export * from "./AdministrationForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports